import { createContext, useContext } from "react";

interface ConfirmDialogContextValue {
  openFromTrigger: () => void;
}

export const ConfirmDialogContext = createContext<ConfirmDialogContextValue>({ openFromTrigger: () => {} });

export const useConfirmDialogContext = () => useContext(ConfirmDialogContext);
